<template>
  <card body-classes="px-0 pb-1" class="no-border-card" footer-classes="pb-2">
    <template slot="header">
      <h3 class="mb-0">Todos las Cotizaciones de Dólar</h3>
    </template>

    <div>
      <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
        <el-select v-model="pagination.perPage" class="select-primary pagination-select" placeholder="Per page">
          <el-option
            v-for="item in pagination.perPageOptions"
            :key="item"
            :label="item"
            :value="item"
            class="select-primary"
          >
          </el-option>
        </el-select>

        <div></div>

        <div>
          <base-input v-model="searchQuery" placeholder="Buscar..." prepend-icon="fas fa-search"></base-input>
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <el-table
        :data="queriedData"
        cy-id="dollar-quotations-table"
        header-row-class-name="thead-light"
        row-key="id"
        @sort-change="sortChange"
      >
        <el-table-column label="Fecha" min-width="120px" sortable>
          <template #default="{ row }">
            <div v-if="row.date">{{ row.date | date }}</div>
          </template>
        </el-table-column>

        <el-table-column label="Divisa" min-width="200px">
          <template #default="{ row }">
            <div v-if="row.divisa">{{ row.divisa | toCurrencyARS }}</div>
          </template>
        </el-table-column>

        <el-table-column label="Billete" min-width="200px">
          <template #default="{ row }">
            <div v-if="row.billete">{{ row.billete | toCurrencyARS }}</div>
          </template>
        </el-table-column>

        <el-table-column label="Manual" min-width="200px">
          <template #default="{ row }">
            <div v-if="row.manual">{{ row.manual | toCurrencyARS }}</div>
          </template>
        </el-table-column>

        <el-table-column align="right" label="" min-width="140px">
          <div slot-scope="{ row }" class="d-flex">
            <router-link
              v-if="$can('update', 'dollar_quotations')"
              :to="{ name: 'DollarQuotationEdit', params: { id: row.id } }"
              cy-id="edit-dollar"
              class="btn base-button btn-outline-primary btn-sm"
            >
              <i class="fas fa-pen"></i>
            </router-link>
          </div>
        </el-table-column>
      </el-table>
    </div>
    <div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
      <div class="">
        <p class="card-category">Mostrando {{ from + 1 }} a {{ to }} de un total de {{ total }} Cotizaciones</p>
      </div>
      <base-pagination
        v-model="pagination.currentPage"
        :per-page="pagination.perPage"
        :total="total"
        class="pagination-no-border"
      >
      </base-pagination>
    </div>
  </card>
</template>

<script>
import { BasePagination } from '@/components';
import { Table, TableColumn, DropdownMenu, DropdownItem, Dropdown, Select, Option } from 'element-ui';
import PaginationMixin from '@/mixins/paginationMixin';
import { mapActions } from 'vuex';

export default {
  name: 'DollarQuotationsTable',
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    BasePagination,
  },

  mixins: [PaginationMixin],

  data() {
    return {
      searchKeys: ['date', 'divisa', 'billete', 'manual'],
      tableData: [],
      tableName: 'DollarQuotationsTable',
    };
  },

  mounted() {
    this.fetchCurrentDollarQuotation();
    this.getDollarQuotations();
  },

  methods: {
    ...mapActions('dollarQuotation', ['fetchCurrentDollarQuotation']),

    getDollarQuotations() {
      this.$services
        .resource('dollar_quotations')
        .get({ sort: '-date' })
        .then((res) => res.data.data)
        .then((data) => (this.tableData = data));
    },
  },
};
</script>
